import React from 'react';
import Head from 'next/head';
import { makeStore } from 'reducers/store';
import { GraphQLAPI } from 'utils/RTKGraphQL';
import { formatDefaultDate } from 'utils/misc';
import { getLevels } from 'controllers/SkillController';
import Taxon from 'features/Taxon';

export async function getStaticPaths() {
  const store = makeStore();
  const taxonsResult = await store.dispatch(
    GraphQLAPI.endpoints.getTaxons.initiate()
  );
  const taxons = taxonsResult.data;

  console.log('taxon endpoint', GraphQLAPI.endpoints.getTaxons);

  console.log('Taxons API Response:', {
    data: taxonsResult.data,
    error: taxonsResult.error,
    isLoading: taxonsResult.isLoading,
  });

  //const paths = []

  const paths = taxons.map((taxon) => ({
    params: { taxon: taxon.url },
  }));

  return { paths, fallback: 'blocking' };
}

export async function getStaticProps({ params }) {
  const store = makeStore();
  const state = store.getState();

  const showRead = state.languageSettings?.showRead || true;
  const skills = state.skillSettings?.skill ?? [];
  const date = state.date;
  const hsks = getLevels(skills);
  const categories = state.skillSettings?.cats ?? [];
  const profile = state.profile;
  const userId = profile ? profile.id : null;

  console.log('Initial state values:', {
    showRead,
    skills,
    hsks,
    categories,
    userId,
    date,
  });

  // Fetch taxon by slug
  const taxonResult = await store.dispatch(
    GraphQLAPI.endpoints.getTaxonBySlug.initiate(params.taxon)
  );

  console.log('Taxon result:', taxonResult);

  const taxon = taxonResult.data;

  //console.log('TAXON DATA', taxon);
  //console.log('TAXON RESULT', taxonResult);

  if (!taxon) {
    return {
      notFound: true,
    };
  }

  // Log before category articles query
  console.log('Making category articles query with:', {
    taxonId: taxon?.id,
    categoryIds: categories,
    hsks,
    userId,
  });

  // Fetch category articles for the taxon
  const categoryArticlesResult = await store.dispatch(
    GraphQLAPI.endpoints.getCollectionsByCategory.initiate({
      taxonId: taxon.id,
      categoryIds: categories,
      limit: 15,
      offset: 0,
      ordering: '-date',
      published: true,
      displaySkill: hsks,
      fillToLimit: true,
      showRead: showRead,
      start: formatDefaultDate(date.start_date),
      end: formatDefaultDate(date.end_date),
      userId: userId,
    })
  );

  console.log(
    'Category articles result:',
    JSON.stringify(categoryArticlesResult, null, 2)
  );

  const categoryArticles = categoryArticlesResult.data;

  // Fetch recent articles for the taxon
  const recentArticlesResult = await store.dispatch(
    GraphQLAPI.endpoints.getCollectionsByTaxon.initiate({
      taxonId: taxon.id,
      limit: 15,
      ordering: '-date',
      published: true,
      displaySkill: hsks,
      fillToLimit: true,
      userId: userId,
    })
  );
  const recentArticles = recentArticlesResult.data;

  // If both queries fail, return notFound
  if (!categoryArticles && !recentArticles) {
    return {
      notFound: true,
    };
  }

  console.log('Final data being returned:', {
    taxon,
    categoryArticles,
    recentArticles,
  });

  return {
    props: {
      taxon,
      initialCategoryArticles: categoryArticles,
      initialRecentArticles: recentArticles,
      showRead,
      hsks,
      categories,
      userId,
      startDate: formatDefaultDate(date.start_date),
      endDate: formatDefaultDate(date.end_date),
    },
    revalidate: 21600, // Revalidate every 6 hours
  };
}

const TaxonPage = ({
  taxon,
  initialCategoryArticles,
  initialRecentArticles,
  ...props
}) => {
  if (!taxon) {
    return <div>Taxon not found</div>;
  }

  return (
    <>
      <Head>
        <meta charSet="utf-8" />
        <meta
          name="description"
          content={`${taxon.name} articles on Pandaist - Learn Chinese by Reading`}
        />
        <title>{`${taxon.name} | Pandaist`}</title>
        <link rel="canonical" href={`https://pandaist.com/${taxon.url}`} />
        <meta
          name="twitter:description"
          content={`${taxon.name} articles on Pandaist - Learn Chinese by Reading`}
        />
        <meta property="og:locale" content="en_US" />
        <meta
          property="og:site_name"
          content="Pandaist | Learn Chinese by Reading"
        />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={`${taxon.name} | Pandaist`} />
        <meta
          property="og:description"
          content={`${taxon.name} articles on Pandaist - Learn Chinese by Reading`}
        />
        <meta property="og:url" content={`https://pandaist.com/${taxon.url}`} />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={`${taxon.name} | Pandaist`} />
        <meta
          property="og:image"
          content={'https://cdn.pandaist.com/main/images/bigpanda.png'}
        />
        <meta
          name="twitter:image"
          content={'https://cdn.pandaist.com/main/images/bigpanda.png'}
        />
      </Head>
      <Taxon
        taxonId={taxon.id}
        title={taxon.name}
        initialCategoryArticles={initialCategoryArticles}
        initialRecentArticles={initialRecentArticles}
        {...props}
      />
    </>
  );
};

export default TaxonPage;
